var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fit-tips",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{ref:"inner",staticClass:"fit-tips-inner",style:({animationDuration:_vm.animateTime})},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }